import $ from 'jquery'
// import BitlyAPI from 'node-bitlyapi'

// const bitly = new BitlyClient('<accessToken>', {})

$(document).ready(function () {
    var login = 'comuneroncade'
    var api_key = 'R_48080e939b48417f9f2496a700e2b568'
    var long_url = $('#share').data('long-url')
    var shortUrl
    var reccomend_url
    var dataHref
    var title = $('title').text()

    get_short_url(long_url, login, api_key, function (short_url) {
        $('#share').attr('data-short-url', short_url)
        shortUrl = short_url
    })

    // $('#share').on('click', function () {
    //   var noProtUrl = shortUrl.replace(/(^\w+:|^)\/\//, '')
    //   noProtUrl = noProtUrl.replace('bit.ly/', '')
    //   reccomend_url = "url=" + noProtUrl + "&title=" + escape(title)
    //   dataHref = $('#reccomend-anchor').attr('data-href') + '?'
    //   // $('#reccomend-anchor').attr('href',dataHref + reccomend_url);
    //   // console.log(reccomend_url)
    //   // console.log(dataHref)
    //   reccomend_url = dataHref + reccomend_url
    //   console.log(reccomend_url)
    // })
    //
    // require(['modaal/dist/js/modaal.js', 'modaal/dist/css/modaal.min.css'], () => {
    //   $('#reccomend-anchor').modaal({
    //     // content_source: dataHref + reccomend_url
    //     type: 'ajax',
    //     // content_source: dataHref + reccomend_url,
    //     content_source: reccomend_url,
    //     loading_content: 'Attendere prego...'
    //   })
    // })


    $('#twitter-share').on('click', function () {
        //http://twitter.com/share?text=Text to share&url=http://url goes here&hashtags=ComuneRoncade
        var fullUrl = 'https://twitter.com/share?text='
        if (title.length > 200) {
            title = jQuery.trim(title).substring(0, 200).split(' ').slice(0, -1).join(' ') + ' [...]'
        }

        title += ' >> '

        fullUrl += title + '&url=' + shortUrl + '&hashtags=ComuneSanStino'
        $(this).attr('href', fullUrl)
    })

    $('#whatsapp-share').on('click', function () {
        //whatsapp://send?text=The text to share!
        var fullUrl = 'whatsapp://send?text='
        fullUrl += title + ' >> ' + shortUrl
        $(this).attr('href', fullUrl)
    })
})

function get_short_url(long_url, login, api_key, func) {
    $.getJSON(
        'https://api-ssl.bitly.com/v3/shorten?callback=?',
        {
            'format': 'json',
            'apiKey': api_key,
            'login': login,
            'longUrl': long_url
        },
        function (response) {
            func(response.data.url)
        }
    )
}



// WEBPACK FOOTER //
// ./src/modules/share/index.js